/**
 * Projects MVI Intents
 *
 * Discriminated union of all project actions.
 */

import type { IProject } from "@/shared/api";
import type { IApiError } from "@/shared/types";

// ============================================================================
// Intent Type
// ============================================================================

export type TProjectsIntent =
  | { type: "LOAD_PROJECTS_START" }
  | { type: "LOAD_PROJECTS_SUCCESS"; projects: readonly IProject[] }
  | { type: "LOAD_PROJECTS_ERROR"; error: IApiError }
  | { type: "SELECT_PROJECT"; projectId: string }
  | { type: "CREATE_PROJECT_START" }
  | { type: "CREATE_PROJECT_SUCCESS"; project: IProject }
  | { type: "CREATE_PROJECT_ERROR"; error: IApiError };

// ============================================================================
// Intent Creators
// ============================================================================

export const intents = {
  loadProjectsStart: (): TProjectsIntent => ({
    type: "LOAD_PROJECTS_START",
  }),

  loadProjectsSuccess: (projects: readonly IProject[]): TProjectsIntent => ({
    type: "LOAD_PROJECTS_SUCCESS",
    projects,
  }),

  loadProjectsError: (error: IApiError): TProjectsIntent => ({
    type: "LOAD_PROJECTS_ERROR",
    error,
  }),

  selectProject: (projectId: string): TProjectsIntent => ({
    type: "SELECT_PROJECT",
    projectId,
  }),

  createProjectStart: (): TProjectsIntent => ({
    type: "CREATE_PROJECT_START",
  }),

  createProjectSuccess: (project: IProject): TProjectsIntent => ({
    type: "CREATE_PROJECT_SUCCESS",
    project,
  }),

  createProjectError: (error: IApiError): TProjectsIntent => ({
    type: "CREATE_PROJECT_ERROR",
    error,
  }),
};
